
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CaoService } from 'src/app/services/cao.service';
import { BaseService } from 'src/app/services/common/base.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-tank-stage2-aby-pfms-report',
  templateUrl: './tank-stage2-aby-pfms-report.component.html',
  styleUrls: ['./tank-stage2-aby-pfms-report.component.scss']
})
export class TankStage2AbyPfmsReportComponent implements OnInit {

  @ViewChild('farmerShareToVendorPFMSReportTable', { static: true }) public farmerShareToVendorPFMSReportTable: any;

  selectedBankAccounts: any[];

  submitted: boolean;
  menuItems: MenuItem[];

  statuses: any[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  farmerShareToVendorPFMSReportModel: any[];
  addDialog: boolean;

  lotNo: number;
  public filteredData: any = [];
  selectedStatus: any;
  remarks: String;
  date: any;
  public userID: any;
  miSurveyData: any[];
  items: any[];
  appVerificationItems: MenuItem[];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  filteredDataForExport: any = [];
  ipAddress: any = '000.000.000';
  public loading: boolean = false;
  public loading1: boolean = false;
  public subscriptions: any = [];

  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService, 
    private caoService: CaoService, 
    private router: Router,
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private ipService: IpAddressService, 
    private dashboard: DashboardService,  
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService
    ) { }

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData();
    this.loadDataAndApplyFilter();
    this.date = new Date();

    this.getIP();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.farmerShareToVendorPFMSReportModel, "Pond Survey Tank Stage 2 PFMS Report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.farmerShareToVendorPFMSReportModel, "Pond Survey Tank Stage 2 PFMS Report");
        }
      },
    ];


    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.pfmsExportExcel(this.miSurveyData, `${this.lotNo}_(${this.date})`);
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Lot Data__(${this.date})`);
      //   }
      // },
    ];

  }
  
  
  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.loadData();
   
        this.selectedYear = res;
        this.farmerShareToVendorPFMSReportTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }

  refreshTable(){
    this.loadData();
  }

  loadData() {
    // this.loader.start();
    let reqBody = {
      Stage: 2,
      UserType: "isAtal",
      FinYear: ''
    }

    this.loading = true;
    let sub=this.caoService.getApplicatonsForPondSubsidyPFMSReportsByStageId(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
           // this.loader.close();
           this.loading = false;
          data = data.map(val => ({ 
            ...val,
            lotNoForSorting: parseInt(val?.Lot_No.slice(7))
          }))
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-2 PFMS Report (ABY)', '', new Date(), 'Success');

          if (data.length > 0) {
            this.farmerShareToVendorPFMSReportModel = data;
          }
        },
        error: (err) => {
           // this.loader.close();
           this.loading = false;
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-2 PFMS Report (ABY)', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error!  not loaded.' });

        }
      });
      this.subscriptions.push(sub);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Srno', header: 'Sr No' },
      { field: 'Lot_No', header: 'File No' },
      { field: 'dateofExport', header: 'Date of Export' },
      { field: 'No_of_AllRecords', header: 'No of Record' },
      { field: 'Sum_of_PFMS_Export', header: 'Sum of PFMS Export' },
      { field: 'Sum_of_Centre_Share', header: 'Sum of Center Share Amount' },
      { field: 'Sum_of_State_Share', header: 'Sum of State Share Amounth' },
      { field: 'SumOfTopUp_AllRec', header: 'Sum of TopUp Amount' },
      { field: 'SumOfABY_AllRec', header: 'Sum of ABY Amount' },
      { field: 'No_of_Successfull_Records', header: 'No of Successfull Records' },
      { field: 'Sum_of_Successfull_Records', header: 'Sum of Successfull Records' },
      { field: 'No_of_Failed_Records', header: 'No of Failed Records' },
      { field: 'Sum_of_Failed_Records', header: 'Sum of Failed Records' },
      { field: 'Sum_of_Bank_Transfer_Successfull_Records', header: 'Sum of Bank Transfer Successfull Records' }
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }


  hideDialog() {
    this.addDialog = false;
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Sr No": d.Srno,
          "File No": d.Lot_No,
          "Date of Export": d.dateofExport,
          "No of Record": d.No_of_AllRecords,
          "Sum of PFMS Export": d.Sum_of_PFMS_Export,
          "Sum of Center Share Amount": d.Sum_of_Centre_Share,
          "Sum of State Share Amount": d.Sum_of_State_Share,
          "Sum of TopUp Amount": d.SumOfTopUp_AllRec,
          "Sum of ABY Amount": d.SumOfABY_AllRec,
          "No of Successfull Records": d.No_of_Successfull_Records,
          "Sum of Successfull Records": d.Sum_of_Successfull_Records,
          "No of Failed Records": d.No_of_Failed_Records,
          "Sum of Failed Records": d.Sum_of_Failed_Records,
          "Sum of Bank Transfer Successfull Records": d.Sum_of_Bank_Transfer_Successfull_Records,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }


  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

     // this.loader.start();
     this.loading = true;
     let sub= this.deptDashBoardService.insertMISubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
           // this.loader.close();
           this.loading = false;
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
          this.pmfsExport(reqBody.Lot_No, '');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
      this.subscriptions.push(sub);
  }

  pmfsExport(lotId, status) {
    this.addDialog = true;
    this.lotNo = lotId;
    let tankStage = 2;
     // this.loader.start();
    this.loading1 = true;
    let sub=this.caoService.getApplicationsForPondFarmerShareToVendorPFMSExportByLotId(lotId, tankStage, status, 'isAtal')
      .pipe(first())
      .subscribe({
        next: (data) => {
           // this.loader.close();
           this.loading1 = false;
          // console.log("dataaa", data)
          if (data?.length > 0) {
            this.miSurveyData = data;
            this.miSurveyData = this.miSurveyData.map(row => ({
              ...row,
              AppId_ProgID: row.Scheme_Specific_Id.concat("_", row.ProgramID)
            }))
            // console.log("RTFdata", this.miSurveyData)
          }
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-2 PFMS Export (ABY)', lotId, new Date(), 'Success');
        },
        error: (err) => {
          // this.loader.close();
          this.loading1 = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-2 PFMS Export (ABY)', lotId, new Date(), err);
        }
      });
      this.subscriptions.push(sub);
  }

  selectFarmerApplication(application) {
    if(application.Scheme_Specific_Id){
      // this.loader.start();
    this.loading = true;
      let sub=this.dashboard
      .getMIDetailByAppID(application.Scheme_Specific_Id)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          this.loading = false;
          const link = this.router.serializeUrl(
            this.router.createUrlTree([
              this.router.url.split('/')[1],
              'print',
            ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
          // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
          window.open(link, '_blank');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
      this.subscriptions.push(sub);
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  pfmsExportExcel(modelData, filename) {
    this.countNoOfTimesExported();
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Full Name in English': d.Farmer_Name_In_English,
          'Full Name in Recognized Official Language': d.Full_Name_in_Recognized_Official_Language,
          'Caste Description': d.Caste_Description,
          'Gender': d.Gender,
          'Address line 1': d.Address_Line_1,
          'Address Line 2': d.Address_Line_2,
          'Address Line 3': d.Address_Line_3,
          'District': d.District,
          'State': d.State,
          'Country': d.Country,
          'Bank Name': d.Farmer_Bank_Name,
          'IFSCCode': d.Farmer_IFSCCode,
          'Account Number': d.Farmer_Account_Number ? d.Farmer_Account_Number.toString(): '',
          'Aadhar Number': d.Aadhar_Number ? d.Aadhar_Number.toString() : '',
          'Pincode': d.Pincode,
          'Scheme Specific ID': d.Scheme_Specific_Id,
          'Center Share Payment Amount': d.Center_Share_Payment_Amount,
          'State Share Payment Amount' : d.State_Share_Payment_Amount,
          'ABY' : d.ABY,
          'Top Up' : d.TopUp,
          'Application Type' : d.Applicant_type,
          'User Type' : d.userType,
          'Coverage Area' : d.Coverage_Area,
          'Remarks' : d.Remarks,
          'CAO Remarks' : d.CAORemarks,
          // 'Subsidy Amount': d.Subsidy_Amt,
          // 'ApprovalDate': d.ApprovalDate
          //user need to enter
          'status': '',
          'remarks': '',
          'PFMS Payment Date': '',
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  countNoOfTimesExported(){
    let reqBody = {
      lotType: 'TS2',
      subLotType: 'ABY',
      lotNo: this.lotNo,
      userId: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress 
    }

    this.postCountExportDataFrequency(reqBody);
  }

  postCountExportDataFrequency(reqBody) {
    this.loader.start();
    this.deptDashBoardService
      .postCountExportDataFrequency(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data.Result == 'Success'){
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: data.Result,
            });
          }else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data.Result,
            });
          }
          this.loadData();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  rowBackgroundColor(row) {
    if (row.PendingCompletedDays <= -2) {
      //red
      return '#ff8080';
    }else if (row.PendingCompletedDays == -1) {
      //orange
      return '#ffc966';
    }else if (row.PendingCompletedDays == 0) {
      //light green
      return '#99e699'
    }else return '#ffffff'; 
  }
}

